export enum ExternalIntegrationPurpose {
    ClientTextChat = 'client_text_chat',
    ClientVoice = 'client_voice',
    AgentTextChatSuggestions = 'agent_text_chat_suggestions',
    AgentAudioSuggestions = 'agent_audio_suggestions',
    STT = 'stt',
    TTS = 'tts',
    ClientConnect = 'client_connect',
    ConversationSummary = 'conversation_summary',
    Translation = 'translation',
    Avatar = 'avatar',
    TextChatCompliance = 'text_chat_compliance',
    AudioCompliance = 'audio_compliance',
    AgentChatbot = 'agent_chatbot'
}